<template>
    <pg-page title="Private Gym - Aanmelden"
             header="Schrijf je in"
             id="subscription-attach"
             :footer="false"
    >

        <div class="row">
            <div class="col"></div>
            <div class="col col-md-4">
                <a class="btn btn-primary w-100 btn btn-lg btn-primary" href="/abonnementen">
                    <i :class="'fa-solid fa-chevron-right me-2 deze2'"></i> Klik hier om naar de abonnementen pagina te gaan
                </a>
            </div>
            <div class="col"></div>
        </div>

<!--        <div class="mx-auto mt-4">-->
<!--            <form novalidate>-->
<!--                <div class="row g-3  justify-content-center">-->
<!--                    <div class="col-sm-6 text-center order-1">-->
<!--                        <div class="card mb-2 rounded-3 shadow-sm">-->
<!--                            <div class="card-header py-3">-->
<!--                                <div class="d-flex">-->
<!--                                    <h4 class="my-0 fw-normal">Abonnement</h4>-->
<!--                                    <div class="ms-auto"><a href="/prijzen">Aanpassen</a></div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <div class="card-body">-->
<!--                                <h1 class="card-title pricing-card-title d-inline">€{{ price }}</h1><span class="text-muted fw-light"> / week</span>-->
<!--                                <ul class="list-group list-group-flush">-->
<!--                                    <li class="list-group-item"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check" viewBox="0 0 16 16">-->
<!--                                        <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"/>-->
<!--                                    </svg> Onbeperkt reserveren</li>-->
<!--                                    <li class="list-group-item"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check" viewBox="0 0 16 16">-->
<!--                                        <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"/>-->
<!--                                    </svg> 24/7 Toegang </li>-->
<!--                                    <li class="list-group-item"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check" viewBox="0 0 16 16">-->
<!--                                        <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"/>-->
<!--                                    </svg> Altijd een eiland voor jezelf</li>-->
<!--                                    <li class="list-group-item"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check" viewBox="0 0 16 16">-->
<!--                                        <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"/>-->
<!--                                    </svg> Schema's in de app</li>-->
<!--                                    <li class="list-group-item"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check" viewBox="0 0 16 16">-->
<!--                                        <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"/>-->
<!--                                    </svg> Anti-sponsor garantie</li>-->
<!--                                    <li class="list-group-item"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check" viewBox="0 0 16 16">-->
<!--                                        <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"/>-->
<!--                                    </svg>-->
<!--                                        {{ looptijdString }}</li>-->
<!--                                    <li v-if="personalTrainingString.length" class="list-group-item"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check" viewBox="0 0 16 16">-->
<!--                                        <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"/>-->
<!--                                    </svg>-->
<!--                                        {{ personalTrainingString }}-->
<!--                                    </li>-->
<!--                                    <li v-if="stokAchterDeDeurString.length" class="list-group-item"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check" viewBox="0 0 16 16">-->
<!--                                        <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"/>-->
<!--                                    </svg>-->
<!--                                        {{ stokAchterDeDeurString }}-->
<!--                                    </li>-->

<!--                                </ul>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="col-sm-6 text-center order-2">-->
<!--                        <div class="card mb-2 rounded-3 shadow-sm">-->
<!--                            <div class="row g-2 m-2 mb-3">-->
<!--                                <div class="col-12">-->
<!--                                    <div class="row">-->
<!--                                        <div class="col-sm-6 col-12">-->
<!--                                            <div class="form-floating mb-2 mb-sm-0">-->
<!--                                                <input v-model="first_name" type="text" v-bind:class="{-->
<!--                                                    'form-control': true,-->
<!--                                                    'is-invalid': errors.first_name,-->
<!--                                                    'is-valid': typeof errors.first_name === 'undefined' && wasValidated,-->
<!--                                                }"-->
<!--                                                       id="firstName" placeholder="Voornaam" required>-->
<!--                                                <label for="firstName">Voornaam <span class="text-muted">*</span></label>-->
<!--                                                <div class="invalid-feedback">-->
<!--                                                    {{ errors.first_name }}-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                        <div class="col-sm-6 col-12">-->
<!--                                            <div class="form-floating">-->
<!--                                                <input v-model="last_name" type="text"  v-bind:class="{-->
<!--                                                    'form-control': true,-->
<!--                                                    'is-invalid': errors.last_name,-->
<!--                                                    'is-valid': typeof errors.last_name === 'undefined' && wasValidated,-->
<!--                                                }"-->
<!--                                                       id="lastName" placeholder="Achternaam" required>-->
<!--                                                <label for="lastName">Achternaam <span class="text-muted">*</span></label>-->
<!--                                                <div class="invalid-feedback">-->
<!--                                                    {{ errors.last_name }}-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->



<!--                                <div class="form-floating">-->
<!--                                    <input v-model="email" type="email"-->
<!--                                           v-bind:class="{-->
<!--                                                    'form-control': true,-->
<!--                                                    'is-invalid': errors.email,-->
<!--                                                    'is-valid': typeof errors.email === 'undefined' && wasValidated,-->
<!--                                                }"-->
<!--                                           id="email" placeholder="Email"  name="email" >-->
<!--                                    <label for="email" class="form-label">Email <span class="text-muted">*</span></label>-->
<!--                                    <div class="invalid-feedback">-->
<!--                                        {{ errors.email }}-->
<!--                                    </div>-->
<!--                                </div>-->



<!--                                <div class="form-floating">-->
<!--                                    <input v-model="phone_number" type="text"-->
<!--                                           v-bind:class="{-->
<!--                                                    'form-control': true,-->
<!--                                                    'is-invalid': errors.phone_number,-->
<!--                                                    'is-valid': typeof errors.phone_number === 'undefined' && wasValidated,-->
<!--                                                }"-->
<!--                                           id="telephone" placeholder="Telefoonnummer" name="phone_number" required="">-->
<!--                                    <label for="email" class="form-label">Telefoon <span class="text-muted">*</span></label>-->
<!--                                    <div class="invalid-feedback">-->
<!--                                        {{ errors.phone_number }}-->
<!--                                    </div>-->
<!--                                </div>-->

<!--                                <div class="form-floating">-->
<!--                                    <input v-model="password" type="password"-->
<!--                                           v-bind:class="{-->
<!--                                                    'form-control': true,-->
<!--                                                    'is-invalid': errors.password,-->
<!--                                                    'is-valid': typeof errors.password === 'undefined' && wasValidated,-->
<!--                                                }"-->
<!--                                           id="password" name="password" required placeholder="Wachtwoord">-->
<!--                                    <label for="password" class="form-label">Gewenst wachtwoord <span class="text-muted">(10+ karakters)</span></label>-->
<!--                                    <div class="invalid-feedback">-->
<!--                                        {{ errors.password }}-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="form-floating">-->
<!--                                    <input v-model="password_confirmation" type="password"-->
<!--                                           v-bind:class="{-->
<!--                                                    'form-control': true,-->
<!--                                                    'is-invalid': errors.password_confirmation,-->
<!--                                                    'is-valid': typeof errors.password_confirmation === 'undefined' && wasValidated,-->
<!--                                                }"-->
<!--                                           id="password_confirmation" name="password_confirmation" required placeholder="Wachtwoord">-->
<!--                                    <label for="password" class="form-label">Wachtwoord <span class="text-muted">(nogmaals)</span></label>-->
<!--                                    <div class="invalid-feedback">-->
<!--                                        {{ errors.password_confirmation }}-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div :class="'m-1 mt-3 form-check ' + (!legal && submitted ? ' text-danger fw-bold' : '')">-->
<!--                                    <input v-model="legal" class="form-check-input" type="checkbox">-->
<!--                                    <small class="form-check-label">-->
<!--                                        Ik ben akkoord met de <a href="/legal/algemene-voorwaarden">Algemene voorwaarden</a> en <a href="/legal/privacy-policy">Privacy policy</a>-->
<!--                                    </small>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->

<!--                        <div class="card  text-dark bg-warning mb-2 rounded-3 shadow-sm" v-if="subPrice">-->
<!--                            <div class="m-2">-->
<!--                                Je doet hierna ter verificatie een betaling van €{{subPrice}} voor de eerste week. Automatische afschrijvingen starten vervolgens 7 dagen <em>na</em> je eerste training.-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="card mb-2 rounded-3 shadow-sm">-->
<!--                            <div class="m-2">-->
<!--                                <button @click.prevent="send" type="button" class="w-100 btn btn-lg btn-primary" :disabled="loading">-->
<!--                                    <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>-->
<!--                                    <i  v-if="!loading" :class="'fa-solid fa-chevron-right me-2'"></i> Word nu lid-->
<!--                                </button>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </form>-->
<!--        </div>-->

    </pg-page>
</template>

<script>

import PgPage from "../../../Components/PgPage";
import ContactModal from "../../../Components/Contact/ContactModal";
import axios from "axios";
export default {
    components: {ContactModal, PgPage},

    props: [],

    mixins: [],

    data: function () {
        return {
            loading: false,
            wasValidated: false,
            errors: {},
            submitted: false,

            showFormModal: false,
            first_name: '',
            last_name: '',
            email: '',
            password: '',
            password_confirmation: '',
            legal: false,

            looptijd: 12,
            personalTraining: 'eenmalig',
            stokAchterDeDeur: 0,
            price: '9,99',
        };
    },

    computed: {
        hasChoosenSubscription() {
            return this.subscription_looptijd !== null && this.subscription_personalTraining !== null && this.subscription_stokAchterDeDeur !== null;
        },
        subPrice() {
            return localStorage.getItem('subscription_price');
        },
        subscription_looptijd() {
            return localStorage.getItem('subscription_looptijd');
        },
        subscription_personalTraining() {
            return localStorage.getItem('subscription_personalTraining');
        },
        subscription_stokAchterDeDeur() {
            return localStorage.getItem('subscription_stokAchterDeDeur');
        },
        looptijdString() {
            return 'Looptijd van minimaal ' + this.looptijd + ' ' + (this.subscription_looptijd == 1 ? 'maand' : 'maanden');
        },
        personalTrainingString() {
            if(this.personalTraining === 'eenmalig') {
                return 'Eenmalig een techniek training'
            }
            if(parseInt(this.personalTraining) > 0) {
                return this.personalTraining + 'x per 4 weken PT'
            }
            return '';
        },
        stokAchterDeDeurString() {
            if(parseInt(this.stokAchterDeDeur) > 0) {
                return 'StokAchterDeDeur: "ik ga minimaal ' + this.stokAchterDeDeur + 'x per week trainen"'
            }
            return '';
        }
    },

    created() {
        if(this.subscription_looptijd !== null) {
            this.looptijd = parseInt(this.subscription_looptijd);
        }
        if(this.subscription_personalTraining !== null) {
            this.personalTraining = this.subscription_personalTraining;
        }
        if(this.subscription_stokAchterDeDeur !== null) {
            this.stokAchterDeDeur = parseInt(this.subscription_stokAchterDeDeur);
        }
        // This one last, as it should be set after the others
        if(this.subPrice !== null) {
            this.price = this.subPrice;
        }
    },

    mounted() {
        //
    },

    methods: {
        send() {
            this.submitted = true;
            if(!this.legal) {
                return;
            }

            const vm = this;
            this.loading = true;
            this.errors = {};
            this.wasValidated = false;

            window.axios.post(process.env.MIX_API_URL + '/api/v1/subscription', {
                first_name: this.first_name,
                last_name: this.last_name,
                email: this.email,
                phone_number: this.phone_number,
                password: this.password,
                password_confirmation: this.password_confirmation,

                looptijd: parseInt(this.looptijd),
                personal_training: this.personalTraining,
                stok_achter_de_deur: parseInt(this.stokAchterDeDeur),
            })
                .then(function (response) {
                    vm.wasValidated = true;
                    let paymentLink = response.data.data;
                    window.location.href = paymentLink;
                })
                .catch(function (error) {
                    vm.loading = false;
                    if (typeof error.response.data.errors !== 'undefined') {
                        Object.keys(error.response.data.errors).forEach(formName => {
                            error.response.data.errors[formName].forEach(errorMessage => {
                                vm.errors[formName] = errorMessage;
                            });
                        })
                    }
                    vm.wasValidated = true;
                });
        },
    },

    watch: {
        //
    }
};
</script>
<style lang="scss">
    #lid-worden label {
        font-weight: bold;
        color: red;
    }
</style>
